// РУКА 2. Мягкие переносы в длинных названиях: слово ломается только если не помещается,
// и только в правильном месте — «Термо-регуляторы», «Водо-снабжение». Иначе дефиса не видно.
const SHY = "­";
const BREAKS: [RegExp, string][] = [
  [/(^|[\s(«"])(Термо)(?=[а-яё]{4})/gi, `$1$2${SHY}`],
  [/(^|[\s(«"])(Водо)(?=[а-яё]{4})/gi, `$1$2${SHY}`],
  [/(^|[\s(«"])(Тепло)(?=[а-яё]{4})/gi, `$1$2${SHY}`],
];

export function softBreaks(title: string): string {
  return BREAKS.reduce((s, [re, to]) => s.replace(re, to), title);
}

// Адрес не рвётся в неудачных местах: «ул. Лисицына», «д. Кузнечиха», «офис 101», «Промышленная 1»
// переносятся только целиком (неразрывный пробел вместо обычного).
const NBSP = " ";
export function glueAddress(address: string): string {
  return address
    .replace(/(^|\s)(ЯО|г\.|д\.|ул\.|пр\.|пер\.|офис|ТК)\s/g, `$1$2${NBSP}`)
    .replace(/([А-Яа-яЁё]+)\s(\d+[а-яё]?)(?=[\s,)]|$)/g, `$1${NBSP}$2`);
}

// Число и единица измерения в названии товара не разрываются: «1 кВт», «900 мм», «50 л», «6 бар».
export function glueUnits(name: string): string {
  return name.replace(/(\d)\s(?=(кВт|Вт|мм|см|м|л|бар|кг|шт|сек|°C)(?![а-яё]))/gi, `$1${NBSP}`);
}

// Телефон для показа: +79990000001 → «+7 999 000-00-01». Другой вид номера — как есть.
export function formatPhone(phone: string): string {
  const m = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(phone);
  return m ? `+7 ${m[1]} ${m[2]}-${m[3]}-${m[4]}` : phone;
}
